/* tslint:disable */
/* eslint-disable */
/**
 * DAM PORTAL API
 * API for handling DAM PORTAL operations.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Filter,
    FilterFromJSON,
    FilterFromJSONTyped,
    FilterToJSON,
} from './Filter';

/**
 * A asset search request
 * @export
 * @interface AssetSearchRequest
 */
export interface AssetSearchRequest {
    /**
     * Search query
     * @type {string}
     * @memberof AssetSearchRequest
     */
    query?: string;
    /**
     * By user selected filters
     * @type {Array<Filter>}
     * @memberof AssetSearchRequest
     */
    filters: Array<Filter>;
    /**
     * Current user page, starts with 0
     * @type {number}
     * @memberof AssetSearchRequest
     */
    page: number;
    /**
     * By user selected navigation id
     * @type {number}
     * @memberof AssetSearchRequest
     */
    navigationId?: number;
}

export function AssetSearchRequestFromJSON(json: any): AssetSearchRequest {
    return AssetSearchRequestFromJSONTyped(json, false);
}

export function AssetSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetSearchRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'query': !exists(json, 'query') ? undefined : json['query'],
        'filters': ((json['filters'] as Array<any>).map(FilterFromJSON)),
        'page': json['page'],
        'navigationId': !exists(json, 'navigationId') ? undefined : json['navigationId'],
    };
}

export function AssetSearchRequestToJSON(value?: AssetSearchRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'query': value.query,
        'filters': ((value.filters as Array<any>).map(FilterToJSON)),
        'page': value.page,
        'navigationId': value.navigationId,
    };
}

